module.exports = __webpack_public_path__ + "img/spend_nuevo.03291021.png";